import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./BasicReports.scss";
import Scorecard from "./Scorecard/Scorecard";
import SubjectWise from "./SubjectWise/SubjectWise";
import GoToAdvAnalytics from "./GoToAdvAnalytics/GoToAdvAnalytics";
import GoToAdvAnalytics1 from "./GoToAdvAnalytics1/GoToAdvAnalytics1";
import Buttons from "./Buttons/Buttons";
import PerformanceInsights from "../sharedAnalytics/performanceInsights";
import { MISTAKE_BOOK_PRACTICE_SETS_ANALYTICS_PATH } from "../../../MistakeBook/mistakeBookRoutes";
import isGetAnalyticsReportAitsStyle from "../../utils/isGetAnalyticsReportAitsStyle";
import { isExactSummaryAvailable } from "../../utils/isExactSummaryAvailable";

const AITS_YEARWISE_SOURCES = new Set(["paperlisting", "yearwise"]);

const BasicReports = ({ basicAnalytics }) => {
  const location = useLocation();
  const testDetails = useSelector((state) => state.examSlice.testDetails);
  const testType = useSelector((state) => state.examSlice.testType);
  const isMistakeBookPracticeSet =
    testDetails?.source === "mistake_book_practice_set" ||
    location.state?.fromMistakeBookPracticeSet === true ||
    location.pathname === MISTAKE_BOOK_PRACTICE_SETS_ANALYTICS_PATH;
  const showPerformanceInsights =
    testDetails?.practiceMode !== "practice" &&
    AITS_YEARWISE_SOURCES.has(String(testDetails?.source || ""));
  const hideReattempt = isGetAnalyticsReportAitsStyle({
    testDetails,
    testType,
    routeState: location.state,
  });
  const hasExactSummary = isExactSummaryAvailable(basicAnalytics);
  const showAdvAnalyticsCtas = !isMistakeBookPracticeSet && hasExactSummary;

  return (
    <div className="basic-reports">
      <Scorecard basicAnalytics={basicAnalytics} />
      {showAdvAnalyticsCtas ? <GoToAdvAnalytics /> : null}

      <SubjectWise subjectWiseAnalysis={basicAnalytics?.subject_wise_analysis} />

      {showPerformanceInsights && hasExactSummary ? (
        <PerformanceInsights analytics={basicAnalytics} />
      ) : null}

      {!hasExactSummary ? (
        <p className="basic-reports__unavailable">Summary not available</p>
      ) : null}

      {showAdvAnalyticsCtas && hideReattempt ? (
        <div className="basic-reports__action-row">
          <GoToAdvAnalytics1 inline />
          <Buttons hideReattempt />
        </div>
      ) : (
        <>
          {showAdvAnalyticsCtas ? <GoToAdvAnalytics1 /> : null}
          <Buttons hideReattempt={hideReattempt} hideSeeResponse={!hasExactSummary} />
        </>
      )}
    </div>
  );
};

export default BasicReports;
